/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.1",
    versionName: "0.2.0-nightly.2026.3.1",
    versionChannel: "nightly",
    buildDate: "2026-03-01T00:11:43.320Z",
    commitHash: "54b2bc673a03f731977d5c56feae0de68c4c5707",
};
